import * as Sentry from "@sentry/browser";
import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { logIn, Sync } from "sweet-web/redux/app/actions";
import firebase from "../../firebase";
import { RootState } from "../index";
import {
  AUTH_FAILURE,
  AUTH_INIT,
  AUTH_SUCCESS,
  AuthActionTypes,
  RESET_AUTH
} from "./types";

export const resetAuth = (): AuthActionTypes => {
  return { type: RESET_AUTH };
};

export const authInit = (): AuthActionTypes => {
  return { type: AUTH_INIT };
};

export const authSuccess = (uid: string): AuthActionTypes => {
  return { type: AUTH_SUCCESS, uid };
};

export const authFailure = (error: Error): AuthActionTypes => {
  return { type: AUTH_FAILURE, error };
};

export const Auth = (
  email: string,
  password: string,
  newUser?: boolean
): ThunkAction<Promise<string | null>, RootState, null, Action> => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();

    dispatch(authInit());

    let response: { user: { uid: string } };
    if (newUser) {
      response = await firebase
        .auth()
        .createUserWithEmailAndPassword(email, password);
    } else {
      response = await firebase
        .auth()
        .signInWithEmailAndPassword(email, password);
    }

    return response.user.uid;
  } catch (error) {
    alert(error);
    Sentry.captureException(error);
    dispatch(authFailure(error));

    return null;
  }
};

export const LogIn = (
  email: string,
  password: string
): ThunkAction<Promise<void>, RootState, null, Action> => async (
  dispatch,
  getState
) => {
  try {
    const uid = await Auth(email, password)(dispatch, getState, null);
    if (!uid) {
      return;
    } else {
      dispatch(logIn());
      await Sync()(dispatch, getState, null);
    }
  } catch (error) {
    alert(error);
    Sentry.captureException(error);
    dispatch(authFailure(error));
  }
};

export const ResetPassword = (
  emailAddress: string
): ThunkAction<Promise<boolean>, RootState, null, Action<string>> => async (
  dispatch,
  getState
) => {
  try {
    if (!emailAddress) throw new Error("no email address");
    await firebase.auth().sendPasswordResetEmail(emailAddress);

    return true;
  } catch (error) {
    Sentry.captureException(error);
    console.log(error);

    return false;
  }
};
